import {useQuery} from "react-query";
import {GroupMemberSearchRequest} from "../../models/group";
import groupMemberService from "../../services/GroupMemberService";

export default function useGroupMembers(request: GroupMemberSearchRequest) {
   return useQuery(['group-members', request], () => groupMemberService.search(request));
}